import {
  SELECT_SEARCH,
  INVALIDATE_SEARCH,
  REQUEST_POSTS,
  RECEIVE_POSTS
} from '../actions/SearchActions';

function SelectedSearchReducer(state = '', action) {
  switch (action.type) {
  case SELECT_SEARCH:
    return action.searchQuery;
  default:
    return state;
  }
}


function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
  case INVALIDATE_SEARCH: {
    return Object.assign({}, state, {
      didInvalidate: true
    });
  }
  case REQUEST_POSTS: {
    return Object.assign({}, state, {
      isFetching: true,
      didInvalidate: false
    });
  }
  case RECEIVE_POSTS: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      items: action.posts,
      lastUpdated: action.receivedAt
    });
  }
  case 'CLEAR_POSTS': {
    return {
      isFetching: false,
      didInvalidate: false,
      items: []
    };
  }
  default:
    return state;
  }
}

function PostsBySearchQueryReducer(state = {}, action) {
  switch (action.type) {
  case INVALIDATE_SEARCH:
  case RECEIVE_POSTS:
  case REQUEST_POSTS:
    return Object.assign({}, state, {
      [action.searchQuery]: posts(state[action.searchQuery], action)
    });
  case 'CLEAR_POSTS': {
    return {
      isFetching: false,
      didInvalidate: false,
      items: []
    };
  }
  default:
    return state;
  }
}

export { 
  PostsBySearchQueryReducer, 
  SelectedSearchReducer
};


// WEBPACK FOOTER //
// ./src/reducers/SearchReducer.js